import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiService } from '@core/providers/http';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ComentarioService {
  public params = new HttpParams();

  constructor(private readonly apiService: ApiService) { }

  list(params?: any): Observable<any> {
    return this.apiService.get(`/Comentario`, params ? new HttpParams({
      fromObject: params
    }) : this.params,
    ).pipe(
      map(response => response)
    );
  }

  /**
  * Cria um novo comentario
  * @param comentario
  * @returns Observable<any>
  */
  public store(comentario: any): Observable<any> {
    return this.apiService.post(`/Comentario`, comentario);
  }

  /**
* atualizar comentario
* @param comentario 
* @returns Observable<any>
*/
  public update(comentario: any): Observable<any> {
    return this.apiService.put(`/Comentario`, comentario);
  }

  show(id: string): Observable<any> {
    return this.apiService.get(
      `/Comentario/${id}`,
    ).pipe(
      map(response => response)
    );
  }

  delete(id: string): Observable<any> {
    return this.apiService.delete(
      `/Comentario/${id}`,
    )
  }
}
